/**
 * Created by Mike Naughton on 10/19/17.
 *
 * Some utility functions for parsing arguments
 */

import _ from "underscore";

export default {
  /**
   * Given an argument array and an index, determines if an options hash was supplied at that index (versus a callback function) and returns the parsed options.
   * @note This is most useful for situations where function arguments are of the form `function(arg1, arg2, [options,] cb)`
   * @param {Array} args An arguments array
   * @param {Number} optionIndex The index to look for options
   * @param {Object} [defaultOptions] A hash of default options
   * @return {Object} The default options merged with the parsed options from the arguments.
   */
  parseOptions: function (args, optionIndex, defaultOptions) {
    var opts = _.clone(defaultOptions);
    if (args.length > optionIndex) {
      if (!_.isFunction(args[optionIndex])) {
        opts = args[optionIndex];
      }
    }
    return _.defaults({}, opts, defaultOptions);
  },
  /**
   * Given an argument array and an index, determines where the callback function was provided.
   * @note This is most useful for situations where function arguments are of the form `function(arg1, arg2, [options,] cb)`
   * @param {Array} args An arguments array
   * @param {Number} optionIndex The index to look for options
   * @return {Function} The callback function.
   */
  parseCallback: function (args, optionIndex) {
    var cb = args[optionIndex];
    if (!_.isFunction(cb)) {
      cb = args[optionIndex + 1];
    }
    return cb;
  },
};



//////////////////
// WEBPACK FOOTER
// ./public/js/app/views/map/helpers/ArgHelper.js
// module id = 490
// module chunks = 1